/**
 * 감사 로그 변경 항목(changes) 상세 표시.
 * changes가 없으면 before/after 스냅샷 JSON 폴백을 보여준다.
 */
import type { AdminAuditChange } from '@/entities/admin-user/types';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/components/ui/table';
import React from 'react';
import { formatAuditSnapshotPretty } from './settingsAuditLogData';

type AuditChangesDetailProps = {
  changes: AdminAuditChange[];
  beforeSnapshot?: string | null;
  afterSnapshot?: string | null;
  /** 계정 상세 등 좁은 영역용 */
  compact?: boolean;
};

const formatChangeCell = (value: string | null | undefined): string => {
  const trimmed = value?.trim();
  return trimmed ? trimmed : '—';
};

export const AuditChangesDetail: React.FC<AuditChangesDetailProps> = ({
  changes,
  beforeSnapshot,
  afterSnapshot,
  compact = false,
}) => {
  if (changes.length > 0) {
    return (
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className={compact ? 'w-[120px]' : 'w-[160px]'}>
              항목
            </TableHead>
            <TableHead>변경 전</TableHead>
            <TableHead>변경 후</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {changes.map((change) => (
            <TableRow key={`${change.field}-${change.label}`}>
              <TableCell className="font-medium text-foreground">
                {change.label}
              </TableCell>
              <TableCell className="text-muted-foreground">
                {formatChangeCell(change.before)}
              </TableCell>
              <TableCell className="text-foreground">
                {formatChangeCell(change.after)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    );
  }

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <div className="min-w-0 space-y-2">
        <p className="text-xs font-medium text-muted-foreground">변경 전</p>
        <pre className="overflow-x-auto whitespace-pre rounded-12 bg-muted/50 p-4 font-mono text-xs leading-relaxed text-foreground">
          {formatAuditSnapshotPretty(beforeSnapshot)}
        </pre>
      </div>
      <div className="min-w-0 space-y-2">
        <p className="text-xs font-medium text-muted-foreground">변경 후</p>
        <pre className="overflow-x-auto whitespace-pre rounded-12 bg-muted/50 p-4 font-mono text-xs leading-relaxed text-foreground">
          {formatAuditSnapshotPretty(afterSnapshot)}
        </pre>
      </div>
    </div>
  );
};
